<template>
  <topbar
    :titulo="$t('FINANCEIRO.PRECOS')"
    :subtitulo="$t('FINANCEIRO.PRECOS_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  >
    <template #header>
      <div class="d-flex justify-content-between ml-md-4 gap-1">
        <div></div>
        <div class="d-flex gap-1">
          <b-button variant="success" @click="copiarPrecos" v-if="podeCadastrar">
            <i class="fas fa-copy mr-1"></i>
            {{ $t('FINANCEIRO.COPIAR_PRECOS') }}
          </b-button>
          <b-button variant="info" @click="cadastrar" v-if="podeCadastrar">
            {{ $t('GERAL.CADASTRAR') }}
          </b-button>
        </div>
      </div>
    </template>
  </topbar>
</template>
<script>
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: 'FINANCEIRO.FINANCEIRO' },
        { titulo: 'FINANCEIRO.PRECO' },
      ],
    };
  },
  methods: {
    cadastrar() {
      this.$emit('cadastrar', 'preco');
    },
    copiarPrecos() {
      this.$emit('copiar-precos');
    },
  },
};
</script>
